import type { Weighted } from '../types.js';

/** Standalone nick words Turkish users actually pick as usernames. */
export const TR_HANDLE_WORDS: string[] = [
  'tatlıcadı', 'prenses', 'kuzum', 'reis', 'kanka', 'paşa', 'minnoş', 'bıdık', 'sultan', 'efsane',
  'kraliçe', 'şampiyon', 'tatlış', 'maviş', 'sarışın', 'esmer', 'gülüm', 'cadı', 'afacan', 'yaramaz',
  'şirin', 'pamuk', 'fıstık', 'badem', 'kiraz', 'çilek', 'karamel', 'limon', 'tarçın', 'fındık',
  'pıtırcık', 'bücür', 'uykucu', 'gececi', 'serseri', 'delikanlı', 'ağa', 'hatun', 'kıvırcık', 'boncuk',
  'minik', 'papatya', 'lavanta', 'gülücük', 'melek', 'peri', 'sevimli', 'delidolu', 'garip', 'gezgin',
  'kaptan', 'hoca', 'usta', 'dayı', 'abla', 'kral', 'beyfendi', 'efendi', 'asi', 'yalnızkurt',
  'karadenizli', 'gecekuşu', 'kahvesever', 'çaycı', 'simit', 'lokum', 'şeker', 'tontiş', 'tombik', 'kedicik',
  'pisi', 'ponçik', 'zeytin', 'maymoş', 'cimcime', 'şımarık', 'cici', 'tilki', 'baykuş', 'sincap',
  'kaplumbağa', 'yolcu', 'aslanım', 'kartal', 'pehlivan', 'dertli', 'hüzünlü', 'gülen', 'neşeli', 'kafadar',
];

/** First half of "MaviÇiçek"-style compound handles. */
export const TR_HANDLE_ADJECTIVES: string[] = [
  'Mavi', 'Kızıl', 'Yeşil', 'Mor', 'Altın', 'Gümüş', 'Kara', 'Beyaz', 'Gece', 'Şafak',
  'Sessiz', 'Vahşi', 'Tatlı', 'Asi', 'Yalnız', 'Özgür', 'Çılgın', 'Gizli', 'Sonsuz', 'Hızlı',
  'Cesur', 'Narin', 'Fırtına', 'Buz', 'Ateş', 'Rüya', 'Sihirli', 'Küçük', 'Büyük', 'Uçan',
  'Pembe', 'Turuncu', 'Lacivert', 'Siyah', 'Gri', 'Kırmızı', 'Sarı', 'Deli', 'Mutlu', 'Hüzünlü',
  'Neşeli', 'Şirin', 'Minik', 'Koca', 'Uykucu', 'Sevimli', 'Haylaz', 'Yaramaz', 'Tembel', 'Gururlu',
  'Kayıp', 'Son', 'İlk', 'Sıcak', 'Soğuk', 'Parlak', 'Yorgun', 'Kırık', 'Bulutlu', 'Yağmurlu',
  'Masum', 'Efsane', 'Bilge', 'Asil', 'Yabani', 'Uzak',
];

/** Second half of compound handles. */
export const TR_HANDLE_NOUNS: string[] = [
  'Çiçek', 'Yıldız', 'Rüzgar', 'Deniz', 'Kurt', 'Ay', 'Gül', 'Fırtına', 'Şahin', 'Kartal',
  'Kedi', 'Aslan', 'Kuğu', 'Dalga', 'Bulut', 'Gölge', 'Işık', 'Nehir', 'Orman', 'Kelebek',
  'Ejderha', 'Anka', 'Lale', 'Yağmur', 'Kar', 'Güneş', 'Pati', 'Melek', 'Korsan', 'Yolcu',
  'Kuş', 'Serçe', 'Martı', 'Tilki', 'Panda', 'Baykuş', 'Tavşan', 'Kaplan', 'Papatya', 'Menekşe',
  'Lavanta', 'Zeytin', 'Kiraz', 'Çilek', 'Karamel', 'Kahve', 'Çay', 'Şeker', 'Badem', 'Fındık',
  'Gezgin', 'Prenses', 'Prens', 'Kral', 'Kraliçe', 'Savaşçı', 'Şövalye', 'Ruh', 'Kalp', 'Yürek',
  'Dağ', 'Volkan', 'Şimşek', 'Gökyüzü', 'Okyanus', 'Ada', 'Sokak', 'Gece', 'Yaz', 'Kış',
];

/** Licence-plate codes people append ("ahmet34"); weight ≈ province population (100k). */
export const TR_PLACE_CODES: Weighted[] = [
  { name: '34', weight: 157 }, { name: '06', weight: 58 }, { name: '35', weight: 44 },
  { name: '16', weight: 32 }, { name: '07', weight: 27 }, { name: '42', weight: 23 },
  { name: '01', weight: 23 }, { name: '27', weight: 21 }, { name: '41', weight: 21 },
  { name: '33', weight: 19 }, { name: '21', weight: 18 }, { name: '63', weight: 22 },
  { name: '31', weight: 17 }, { name: '45', weight: 15 }, { name: '38', weight: 14 },
  { name: '55', weight: 14 }, { name: '10', weight: 12 }, { name: '46', weight: 12 },
  { name: '65', weight: 12 }, { name: '09', weight: 11 }, { name: '59', weight: 11 },
  { name: '54', weight: 11 }, { name: '20', weight: 10 }, { name: '48', weight: 10 },
  { name: '26', weight: 9 }, { name: '61', weight: 8 }, { name: '44', weight: 8 },
  { name: '25', weight: 7 }, { name: '52', weight: 8 }, { name: '47', weight: 9 },
];
